import { render, staticRenderFns } from "./view.vue?vue&type=template&id=a0c05212&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=a0c05212&prod&lang=stylus&scoped=true&"
import style1 from "./view.vue?vue&type=style&index=1&id=a0c05212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c05212",
  null
  
)

export default component.exports